import { Component, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import * as _ from 'underscore';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';
import { debug } from 'util';
import { EmailPreview } from './emailPreview';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'email-notification',
    templateUrl: 'emailNotification.html',
})

export class EmailNotification {
    public _baseUrl: any;
    public page = 1;
    public pageSize: any = 10;
    public emailFilter: any = {
        to: [],
        cc: [],
        bcc: [],
        body: '',
        notificationTypes: [],
        notificationGroups: [],
        emailStatuses: [],
        moduleList: [],
        eventIds: [],
        page: 1,
        pageSize: 10,
    };
    public emailNotificationData: any = [];
    public emailPageData: any = [];
    public endingPage = 0;
    public startingPage = 0;
    public showLoading: any = false;
    public closeResult: any;
    public collectionSize: any;
    public notificationTypes: any = [];
    public notificationGroups: any = [];
    public notificationStatus: any = [];
    public selectedGroup: any;
    public selectedStatus: any;
    public selectedTypes: any;
    public isCollapsed: boolean = false;
    public searchTo: any;
    public searchCc: any;
    public searchSubject: any;
    public searchBody: any;
    public trackHides = null;
    public searchBodyOrSubject: any;
    constructor(
        public _global: Configuration,
        public http: HttpClientCustom,
        public share: SharedData,
        public _location: Location,
        public _toaster: ToasterComponent,
        public _sanitizer: DomSanitizer,
        public vcr: ViewContainerRef,
        public translate: TranslateService,
        public modalService: NgbModal) {
        let self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self.getMails();
        self.getNotificationGroups();
        self.getNotificationtypes();
        self.getNotificationStatus();
    }

    public resetFilter() {
        let self = this;
        self.emailFilter = {
            to: [],
            cc: [],
            bcc: [],
            body: '',
            notificationTypes: [],
            notificationGroups: [],
            emailStatuses: [],
            moduleList: [],
            eventIds: [],
            page: 1,
            pageSize: 10,
        };
        self.selectedGroup = null;
        self.selectedStatus = null;
        self.selectedTypes = null;
        self.searchTo = null;
        self.searchCc = null;
        self.searchSubject = null;
        self.searchBody = null;
        self.getMails();
    }

    public applyFilter() {
        let self = this;
        self.isCollapsed = !self.isCollapsed;
        self.getMails();
    }

    public getMails() {
        try {
            let self = this;
            self.emailFilter.page = self.page;
            self.emailFilter.pageSize = self.pageSize;
            if (self.searchCc) {
                self.emailFilter.cc = [];
                self.emailFilter.cc.push(self.searchCc);
            }
            if (self.searchTo) {
                self.emailFilter.to = [];
                self.emailFilter.to.push(self.searchTo);
            }
            if (self.searchSubject) {
                self.emailFilter.subject = self.searchSubject;
            }
            if (self.selectedGroup) {
                self.emailFilter.notificationGroups = [];
                self.emailFilter.notificationGroups.push(self.selectedGroup);
            }
            if (self.selectedStatus) {
                self.emailFilter.emailStatuses = [];
                self.emailFilter.emailStatuses.push(self.selectedStatus);
            }
            if (self.selectedTypes) {
                self.emailFilter.notificationTypes = []
                self.emailFilter.notificationTypes.push(self.selectedTypes);
            }
            if (self.searchBodyOrSubject) {
                self.emailFilter.subjectOrBody = self.searchBodyOrSubject;
            }
            self.showLoading = true;
            let url = self._baseUrl + 'v1/webAdmin/mailMongo/find';
            self.http.post(url, self.emailFilter).subscribe((result) => {
                self.emailNotificationData = result.data.content;
                self.emailPageData = result;
                if (self.emailNotificationData.length === 0) {
                    self.showLoading = false;
                }
                self.collectionSize = result.data.totalElements;
                if (result.last) {
                    self.endingPage = self.collectionSize;
                }
            });
        } catch (e) {
            console.log('getSkeleton error catch', e);
        }
    }
    public OnPageSizeChanged(val) {

        this.pageSize = val;
        this.getMails();
    }
    public clicked() {
        this.trackHides = null;
    }

    public getNotificationtypes() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/mailMongo/notificationTypes';
        self.http.get(url).subscribe((result) => {
            self.notificationTypes = result;
        });
    }

    public getNotificationGroups() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/mailMongo/notificationGroups';
        self.http.get(url).subscribe((result) => {
            self.notificationGroups = result;
        });
    }

    public getNotificationStatus() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/mailMongo/notificationStatus';
        self.http.get(url).subscribe((result) => {
            self.notificationStatus = result;
        });
    }

    public previewEmail(email) {
        let self = this;
        this.share.saveData({ email: email });
        const modalRef = this.modalService.open(EmailPreview)
            .result.then((result) => { }, (reason) => { });
    }

    public searchBodyOrSubjectFunc() {
        let self = this;
        self.getMails();
    }
    public onRefresh() {
        this.getMails();
    }
}



// WEBPACK FOOTER //
// ./src/app/programManagement/emailNotification/emailNotification.ts